import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { Check, Crown, Vote } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL;

export default function PublicElection() {
  const { token } = useParams();
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [saving, setSaving] = useState(null);

  useEffect(() => {
    axios.get(`${API}/api/public/election/${token}`).then((r) => setData(r.data))
      .catch((e) => setError(e.response?.data?.detail || "Link inválido."));
  }, [token]);

  const vote = async (id) => {
    setSaving(id);
    try {
      await axios.post(`${API}/api/public/election/${token}`, { candidate_id: id });
      setData({ ...data, vote: id });
    } catch (e) { setError(e.response?.data?.detail || "Não foi possível votar."); }
    setSaving(null);
  };

  const unvote = async () => {
    try { await axios.delete(`${API}/api/public/election/${token}`); setData({ ...data, vote: null }); }
    catch (e) { setError(e.response?.data?.detail || "Não foi possível anular."); }
  };

  if (error) return <Shell><p className="text-[#FF6B6B]" data-testid="election-error">{error}</p></Shell>;
  if (!data) return <Shell><p className="kw-overline">A carregar…</p></Shell>;
  const open = data.status === "open";
  const coop = data.kind === "coopetidor";
  return (
    <Shell>
      <div className="kw-overline mb-2 flex items-center gap-2"><Vote className="w-4 h-4 text-[#E50000]" /> {coop ? "Vaga no plantel" : "Eleição do Presidente"}</div>
      <h1 className="font-display text-4xl sm:text-5xl font-black uppercase tracking-tighter">
        {coop ? "Novo coopetidor dos " : "Presidente dos "}<span className="text-[#22C55E]">{data.club}</span>
      </h1>
      <p className="text-sm text-[#A3A3A3] mt-3 mb-6 max-w-xl">
        Olá {data.voter}! {open ? (coop ? "Escolhe quem deve ocupar a vaga no plantel. " : "Escolhe quem deve liderar o clube. ") + "Podes mudar o voto até a votação fechar." : "A votação já fechou. Obrigado por participares."}
      </p>
      {data.vote && open && (
        <div className="mb-4 text-sm text-[#22C55E] flex items-center gap-2" data-testid="election-voted">
          <Check className="w-4 h-4" /> O teu voto está registado.
          <button onClick={unvote} className="ml-3 text-xs underline text-[#A3A3A3] hover:text-white" data-testid="election-unvote">
            Anular o meu voto
          </button>
        </div>
      )}
      <div className="grid sm:grid-cols-2 gap-3">
        {data.candidates.map((c) => {
          const mine = data.vote === c.id;
          return (
            <button key={c.id} disabled={!open || saving} onClick={() => vote(c.id)}
              className={`kw-card p-3 flex items-center gap-3 text-left transition-colors ${mine ? "!border-[#E50000] bg-[#E50000]/10" : "hover:border-[#444]"} disabled:cursor-default`}
              data-testid={`election-candidate-${c.id}`}>
              {c.photo_url
                ? <img src={`${API}${c.photo_url}`} alt="" className="w-12 h-12 object-cover" />
                : <div className="w-12 h-12 bg-[#1a1a1a] flex items-center justify-center font-black">{(c.name || "?")[0]}</div>}
              <div className="flex-1 min-w-0">
                <div className="font-bold truncate">{c.name}{c.is_me ? " (tu)" : ""}</div>
                <div className="text-[10px] uppercase tracking-widest text-[#737373]">{c.mbti}</div>
              </div>
              {mine && <Crown className="w-5 h-5 text-[#E50000]" />}
            </button>
          );
        })}
      </div>
    </Shell>
  );
}

const Shell = ({ children }) => (
  <div className="min-h-screen bg-[#0A0A0A] text-white px-5 py-10">
    <div className="max-w-3xl mx-auto kw-fade-up">{children}</div>
  </div>
);
